import axios from "../http";

class Expenses {
  getWarehouseData() {
    const url = "/oa/api/warehouse/list";
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  postImportExpenses(data) {
    const url = "/oa/api/upload/other/fee";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  getFeeCalculate(warehouseId, reportDate) {
    const url = `/oa/api/other/fee/calculate?warehouseId=${warehouseId}&reportDate=${reportDate}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  getFeeList(type) {
    const url = `/oa/api/other/fee/type/list?type=${type}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  getUpdateType(id, status) {
    const url = `/oa/api/other/fee/type/modify?id=${id}&status=${status}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  postDelet(data) {
    const url = "/oa/api/express/carrier/rule/sort/del";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 仓库承运商快递规则基础信息新增 */
  postAddBaseInfo(data) {
    const url = "/oa/api/express/carrier/rule/base/info/add";
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Expenses;
